import { render, staticRenderFns } from "./SolicitorComponent.vue?vue&type=template&id=76619ab8&scoped=true&"
import script from "./SolicitorComponent.vue?vue&type=script&lang=js&"
export * from "./SolicitorComponent.vue?vue&type=script&lang=js&"
import style0 from "./SolicitorComponent.vue?vue&type=style&index=0&id=76619ab8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76619ab8",
  null
  
)

export default component.exports